import { useContext } from "react";
import { LocalizationContext } from "sections/app/localization-context";

export const useLoc = () => {
  const context = useContext(LocalizationContext);
  if(!context) throw new Error("useLoc must be used within a LocalizationProvider");
  return context;
};